import * as chains from './chains';

const DOGECHAINCoins = [
  {
    name: "Doge",
    abbr: "WDOGE",
    address: "", // eth address is fetched from the router
  },
  {
    name: "DEGENDOGE",
    abbr: "DDOGE",
    address: "0xeE0BFf2523c9DA6A78a67BA008575D24808fB6D1",
  },
  {
    name: "Dogechain",
    abbr: "DC",
    address: "0x7B4328c127B85369D9f82ca0503B000D09CF9180",
},
]

const COINS = new Map();
COINS.set(chains.ChainId.DOGECHAIN, DOGECHAINCoins)
export default COINS
